<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Трэк номера</h5>
      </div>
      <div class="card-body">
        <div class="flex justify-content-between mb-2">
          <div>
            <div class="custom-radio">
              <label><input type="radio" v-model="track_type" value="1">
                номера для заявок
              </label>
            </div>
            <div class="custom-radio">
              <label><input type="radio" v-model="track_type" value="2">
                номера для накладных
              </label>
            </div>
          </div>
          <div class="flex justify-content-end flex_gap_5">
            <LoadingButton
              v-if="!scanCommenced"
              title="Запустить сканирование кодов"
              className="btn btn-outline-success"
              :loading="btnLoading"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => commenceScan()"
            />
            <button class="btn btn-default" type="button" @click="openNewTrackModal">
              Новый трэк номер
            </button>
            <LoadingButton
              :title="`Показать не отправленные (${totalOverdue})`"
              className="btn btn-outline-info"
              :loading="btnLoading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => getRecords(1, true, 'overdue')"
            />
            <LoadingButton
              title="Показать все"
              className="btn btn-outline-success"
              :loading="btnLoading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => getRecords(1, true, 'all')"
            />
          </div>
        </div>

        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>

        <template v-if="records && !loading">
          <table class="table table-sm table-hover mt-0">
            <thead>
            <tr>
              <th></th>
              <th></th>
              <th>Трэк номер</th>
              <th>время статуса</th>
              <th>статус</th>
              <th>Заявка</th>
              <th>Создание номера</th>
              <th></th>
              <th>Проверка</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r, i) in records">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>{{ r.data?.lastPoint?.icon }}</td>
              <td>({{ r.id }}) {{ r.number }}</td>
              <td>{{ r.data?.lastPoint?.operationDateTime }}</td>
              <td>{{ r.data?.lastPoint?.operation }}</td>
              <td>
                <template v-if="r.object_id">
                  <button v-if="r.object_type_id === 1" @click="orderToEdit(r.order_id)"
                          class="btn btn-xs btn-outline-info mb-1 mr-1">
                    <i class="icon-fa icon-fa-eye"></i>
                  </button>
                  {{ r.object_id }}
                </template>
              </td>
              <td>{{ printDate(r.created_at) }}</td>
              <td>
                <div>
                  <div v-for="c in r.comments" class="comment">
                    <p>{{ c.text }}</p>
                    <p class="text-muted text-right">({{ c.user_name }}) {{ printDate(c.date) }}</p>
                  </div>
                </div>
                <form @submit.prevent="saveComment">
                  <div class="input-group">
                    <input type="hidden" name="record_id" :value="r.id">
                    <input name="comment" required type="text" placeholder="комментарий" class="form-control">
                    <div class="input-group-append">
                      <button type="submit" class="btn btn-outline-info"><i class="icon-fa icon-fa-save"></i></button>
                    </div>
                  </div>
                </form>
              </td>
              <td>
                <div class="flex align-items-center flex_gap_5">
                  <span>{{ r.date ? printDate(r.date) : null }}</span>
                  <LoadingButton
                    v-if="!commencedScan[r.id] && r.status !== 2"
                    title='<i class="icon-fa icon-fa-refresh"/>'
                    className="btn btn-outline-success"
                    :loading="rescanLoading[r.id]"
                    :color="$constants.LOADING_COLOR"
                    :onClick="() => commenceScan(r.id)"
                  />
                </div>
              </td>
              <td>
                <v-popover
                  :auto-hide="true"
                  v-if="r.data?.events"
                  popoverClass="popover_trace_letter_body"
                  placement="left"
                  trigger="hover"
                >
                  <i class="icon-fa icon-fa-info info_fa"/>
                  <template slot="popover">
                    <div class="popover_post_track_trace">
                      <div v-for="e in [...r.data.events].reverse()">
                        <p class="text-muted">{{ e.operationDateTime }}</p>
                        <p>{{ e.operationAttribute }}</p>
                        <p>{{ e.operationPlaceName }}</p>
                      </div>
                    </div>
                  </template>
                </v-popover>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
        <paginate v-if="paginator"
                  v-model="paginator.current_page"
                  :page-count="paginator.last_page"
                  :page-range="8"
                  :margin-pages="2"
                  :click-handler="getRecords"
                  :prev-text="'&laquo'"
                  :next-text="'&raquo'"
                  :container-class="'pagination'"
                  :prev-class="'page-item'"
                  :prev-link-class="'page-link'"
                  :page-class="'page-item'"
                  :page-link-class="'page-link'"
                  :next-class="'page-item'"
                  :next-link-class="'page-link'"
                  :active-class="'active green_btn'">
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import store from "@/store";
import {customUpdateData} from "@/eventsBus";

export default {
  components: {LoadingButton, Paginate},
  data() {
    return {
      commencedScan: {},
      rescanLoading: {},
      scanCommenced: false,
      savingComment: null,
      loading: false,
      btnLoading: false,
      currentAlias: 'all',
      track_type: 1,
      totalRecords: 0,
      totalOverdue: 0,
      paginator: null,
      records: null,
      filterStatus: 0,
      statuses: {
        1: 'новый трэк',
        3: 'ожидает клиента',
      },
      summary: [],
    }
  },
  watch: {
    track_type() {
      this.getRecords();
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async commenceScan(id = null) {
      if (id) {
        this.$set(this.rescanLoading, id, true);
        this.$set(this.commencedScan, id, true);
      } else {
        this.btnLoading = true;
      }
      const {data} = await api.post('/new/orders/post/track', {
        action: 'startScan',
        id
      });
      if (data.success) {
        this.scanCommenced = !id;
        toastr['success']('Сканирование запущено');
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.btnLoading = false;
    },
    openNewTrackModal() {
      store.dispatch("platform/setGlobalModalData", {
        type: 'NewPostTrackNumber',
        headerText: 'Добавление нового трэк номера для сканирования',
        callBack: () => {
          // setTimeout(() => {
          this.getRecords()
          // }, 200)
        }
      });
    },
    orderToEdit(id, dialog = null) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id});
    },
    updateByFilter(status = 0) {
      this.filterStatus = status;
      this.getRecords();
    },
    async saveComment(e) {
      if (this.savingComment) {
        toastr['warning']('Сохранение комментария в процессе');
        return;
      }
      const record = e.target.elements.record_id.value;
      this.savingComment = +record;
      const comment = e.target.elements.comment.value;
      const {data} = await api.post('/new/orders/post/track', {
        action: 'addComment',
        record_id: record,
        comment: comment
      });
      if (data.success) {
        toastr['success']('Сохранено');
        this.getRecords(this.paginator.current_page, true);
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.savingComment = null;
    },
    async getRecords(page = 1, silent = false, alias = null) {
      if (!silent) this.loading = true;
      if (!alias) {
        alias = this.currentAlias;
      } else {
        this.currentAlias = alias;
      }
      this.btnLoading = true;
      let {data: r_data} = await api.index('/new/orders/posttracks?page=' + page + '&alias=' + alias + '&type=' + this.track_type);
      if (r_data.success) {
        const {data, ...pagination} = r_data.records
        this.paginator = pagination
        this.records = data;
        this.summary = r_data.summary;
        this.totalOverdue = r_data.overdueQty ?? 0;
        if (!this.totalRecords) {
          this.totalRecords = pagination.total;
        }
      }
      this.btnLoading = false;
      this.loading = false;
    }
  }
}

</script>

<style>
.popover_post_track_trace {
  width: 685px;
  max-height: 700px;
  overflow: auto;
}
</style>
<style scoped>
p {
  margin-bottom: 0;
}

.comment {
  background-color: #eaeaea;
  padding: 3px 6px;
  margin-bottom: 2px;
}

.info_fa {
  cursor: pointer;
  background-color: #007bff;
  color: white;
  padding: 3px 7px;
  border-radius: 50%;
}
</style>
